import jsonp from 'jsonp'

/**
 * 微信SDK签名
 */
function wxSignature() {
  const sAppid = 'wxa817069bb040f860'
  const sUrl = encodeURIComponent(window.location.href.split('#')[0])
  const url = `${window.location.protocol}//apps.gzh.qq.com/common/wx/api/thirdpartySign.php?sAppid=${sAppid}&sUrl=${sUrl}`

  jsonp(url, null, (err, data) => {
    if (!err && data.ret === 0) {
      wx.config({
        appId: sAppid,
        debug: false,
        timestamp: data.result.timestamp,
        nonceStr: data.result.nonceStr,
        signature: data.result.signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'hideMenuItems',
          'showMenuItems',
        ],
      })

      wx.ready(() => {
        console.debug('wxjssdk初始化完成~')
      })

      wx.error((res) => {
        console.error('wxjssdk初始化失败!')
        console.error(res)
      })
    }
  })
}

export default wxSignature
